import { fetchClient } from '../../Utils/helpers';
import { GET_TRANSACTIONS, GET_TRANSACTION_DETAILS } from '../actionTypes';

export function getTransactions(query = {}) {
  const { limit = 10, page = 1 } = query;
  return {
    type: GET_TRANSACTIONS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/transactions?limit=${limit}&page=${page}`,
    })
      .then((res) => res.data),
  };
}

export function getTransactionDetails(id) {
  return {
    type: GET_TRANSACTION_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/transactions/${id}`,
    }),
  };
}
